import React from 'react';
import ProductCard from '../cards/ProductCard';

export default function GridView({ products = [] }) {
  if (!products || products.length === 0) {
    return (
      <div className="h-64 flex flex-col items-center justify-center p-8 text-center text-amber-200/60">
        <p className="text-sm font-semibold text-amber-200">Không tìm thấy bao lì xì nào phù hợp.</p>
        <p className="text-xs text-amber-200/50 mt-1">Hãy thử thay đổi khoảng giá hoặc từ khóa tìm kiếm.</p>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 2xl:grid-cols-6 gap-3 sm:gap-4.5 pb-12">
      {products.map((product) => (
        <ProductCard
          key={product.id}
          product={product}
        />
      ))}
    </div>
  );
}
